<template lang="pug">
div
    div.p-a.white.lt.box-shadow
        .row
            .col-md-3.col-sm-4.m-y-sm.pull-right
                hourly-report-filter

            .col-md-3.col-sm-4.m-y-sm.pull-right
                datepicker(
                    :start="$store.state.report.startDate"
                    :end="$store.state.report.endDate"
                )

            .col-md-3.col-sm-4.m-y-sm.pull-right
                .col-md-12
                    outlet-selector(:outlet="$store.state.report.activeOutlet")

    vuetable_hourly
</template>

<script>
import vuetableHourlyTable from './vuetable_hourly';
import hourlyReportFilter from './hourly-report-filter';
import tillFilter from '@js/components/till-filter/till-filter';

export default {
    components: {
        vuetableHourlyTable,
        hourlyReportFilter,
        tillFilter,
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/hourly/hourly-index.vue